const var1 = 'YWFjNzQ5OTRlMmFjZWY0ZGU2MGZjNDZkY2FiMjQxYWJjYm';
const var2 = 'Y5NDdlODE3ZjhhNzI2OWFlMjUzYTg1MjliZmI3MQ==';

export const testVar = var1 + var2;
